import { AuthorizationController as Authorization } from './authorizationController/authorization.controller';

export default Authorization;
